import { paths } from '@farmersdog/constants';
import { Breadcrumbs, Link, PageWidth, Text } from '@farmersdog/corgi-x';
import { Arrow } from '@farmersdog/corgi-x/icons';

import styles from './FullFooter.css';
import { LegalDetails } from './LegalDetails';
import { ContactLinksList, NavigationLinksList } from './LinkItems';
import { NewsletterForm } from './NewsletterForm';

export function FullFooter() {
  return (
    <footer className={styles.container}>
      <PageWidth>
        <div className={styles.breadcrumbs}>
          <Text as="div" variant="heading-16">
            <Link baseColor="white" href={paths.PATH_HOME}>
              Home
            </Link>
          </Text>
          <Arrow className={styles.chevron} />
          <Breadcrumbs stem="/" />
        </div>
        <div className={styles.content}>
          <span className={styles.navigation}>
            <Text as="h4" variant="heading-20" color="white" weight="bold">
              Site Map
            </Text>
            <NavigationLinksList />
          </span>
          <span className={styles.contact}>
            <Text as="h4" variant="heading-20" color="white" weight="bold">
              Contact
            </Text>
            <ContactLinksList />
          </span>
          <span className={styles.newsletter}>
            <Text as="h4" variant="heading-20" color="white" weight="bold">
              Free Health and Nutrition Tips
            </Text>
            <NewsletterForm />
          </span>
        </div>
        <div className={styles.ancillary}>
          <Text as="span" variant="heading-12" color="white">
            Our food is made while playing doo-wop tunes, all with ❤ in the US
          </Text>
        </div>
      </PageWidth>
      <LegalDetails />
    </footer>
  );
}
